import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-integration-category',
  template: `
    <div>
      <div class="mb-6">
        <h2 class="text-base font-semibold text-slate-900">{{ label }}</h2>
        <p *ngIf="description" class="mt-1 text-sm text-slate-500">{{ description }}</p>
      </div>
      <div class="space-y-8">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class IntegrationCategoryComponent {
  @Input() label = '';
  @Input() description = '';
}
